import { Box, Typography } from '@mui/material';
import { Business, ChevronRight } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client/react';
import { GET_LICENSES_WHERE_IS_ADMIN } from '../user.graphql';
import { Card } from './Card';
import { TintedIcon } from './TintedIcon';
import { CountChip } from './CountChip';
import LoadingSpinner from '../../components/LoadingSpinner';

interface AdminLicense {
  id: number;
  companyName?: string | null;
}

interface Props {
  userId: number;
  onCount?(count: number): void;
}

export function AdminLicensesPanel({ userId }: Props) {
  const { loading, error, data } = useQuery<{ licenses: AdminLicense[] }>(GET_LICENSES_WHERE_IS_ADMIN, { variables: { id: userId } });

  const licenses = data?.licenses ?? [];

  if (!loading && !error && licenses.length === 0) return null;

  return (
    <Card
      title="Administrerer"
      action={
        <CountChip count={licenses.length} />
      }
      noBodyPadding>
      {loading && (
        <Box sx={{ p: 3 }}>
          <LoadingSpinner />
        </Box>
      )}
      {error && (
        <Box sx={{ p: 3 }}>
          <span>Feil! {error.message}</span>
        </Box>
      )}
      {licenses.map((lic, i) => (
        <Box
          key={lic.id}
          component={Link}
          to={`/license/${lic.id}`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            px: { xs: 2, sm: 3 },
            py: { xs: 1.5, sm: 1.75 },
            borderTop: i === 0 ? 0 : 1,
            borderColor: 'divider',
            color: 'text.primary',
            textDecoration: 'none',
            '&:hover': { bgcolor: 'action.hover' },
          }}>
          <TintedIcon>
            <Business fontSize="small" />
          </TintedIcon>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body2" color="primary.dark" sx={{ fontWeight: 'fontWeightMedium' }}>
              {lic.companyName || '<Mangler navn>'}
            </Typography>
          </Box>
          <ChevronRight fontSize="small" color="disabled" />
        </Box>
      ))}
    </Card>
  );
}
